import { bool2str, KeyCode } from '../../util';

export class Modal {
    /**
     * @param {Element} modal
     */
    constructor(modal) {
        /**
         * @type {Element}
         * @protected
         */
        this._modal = modal;
        /**
         * @type {Element|null}
         * @protected
         */
        this._backdrop = null;

        this.onBackdropClick = this.onBackdropClick.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);

        if (this._modal !== null) {
            this._init();
            this._useBackdrop = !!this._modal.dataset.backdrop;
        }
    }

    get open() {
        return this._modal.getAttribute('aria-hidden') === 'false';
    }

    set open(value) {
        document.body.style.overflow = value ? 'hidden' : null;
        this._setSiblingsInert(value);
        this._modal.setAttribute('aria-hidden', bool2str(!value));
        if (this._useBackdrop) {
            if (value) this._createBackdrop();
            else this._removeBackdrop();
        }
    }

    onBackdropClick() {
        this.open = false;
    }

    /**
     * @param {KeyboardEvent} e
     */
    onKeyPress(e) {
        if (this.open && !e.ctrlKey && e.keyCode === KeyCode.ESCAPE) {
            this.open = false;
        }
    }

    _createBackdrop() {
        this._backdrop = document.createElement('DIV');
        this._backdrop.className = `modal__backdrop ${this._modal.dataset.backdrop}`;
        this._backdrop.addEventListener('click', this.onBackdropClick);
        this._modal.parentElement.insertBefore(this._backdrop, this._modal);
    }

    _removeBackdrop() {
        if (this._backdrop) {
            this._backdrop.remove();
            this._backdrop = null;
        }
    }

    /**
     * @param {boolean} value
     * @private
     */
    _setSiblingsInert(value) {
        const childNodes = document.body.childNodes;
        const container = this._modal.parentNode.classList.contains('modal-container')
            ? this._modal.parentNode
            : this._modal;
        for (let i = 0; i < childNodes.length; i++) {
            if (childNodes[i] !== container) {
                childNodes[i].inert = value;
            }
        }
    }

    _init(){
        if (this._backdrop !== null) {
            this._backdrop.addEventListener('click', this.onBackdropClick);
        }
        Array.from(this._modal.querySelectorAll('[data-action=close]'))
            .forEach(b => b.addEventListener('click', e => {
                e.preventDefault();
                this.open = false;
            }));
        document.addEventListener('keydown', this.onKeyPress);
    }
}
